import {
    OVERPAYMENT_GRAPH_DATA_REQUEST,
    OVERPAYMENT_GRAPH_DATA_SUCCESS,
    OVERPAYMENT_GRAPH_DATA_FAILURE,
    OVERPAYMENT_GRAPH_DATA_CANCEL,
    OVERPAYMENT_DATA_REQUEST,
    OVERPAYMENT_DATA_SUCCESS,
    OVERPAYMENT_DATA_ERROR,
    OVERPAYMENT_DATA_CANCEL,
    OVERPAYMENT_GRAPH_DATA_LOADING,
    OVERPAYMENT_DATA_LOADING,
    OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_REQUEST,
    OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_SUCCESS,
    OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_FAILURE,
    OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_LOADING,
    OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_CANCEL,
    OVERPAYMENT_POLLING_STARTED,
    OVERPAYMENT_POLLING_COMPLETED,
    OVERPAYMENT_POLLING_FAILED,
    OVERPAYMENT_SUBCATEGORY_REQUEST,
    OVERPAYMENT_SUBCATEGORY_SUCCESS,
    OVERPAYMENT_SUBCATEGORY_FAILURE,
    OVERPAYMENT_SUBCATEGORY_LOADING,
  } from '../actionTypes';
  
  export const fetchOPGraphDataRequest = (payload: any) => ({
    type: OVERPAYMENT_GRAPH_DATA_REQUEST,
    payload,
  });
  
  export const fetchOPGraphDataSuccess = (payload: any) => ({
    type: OVERPAYMENT_GRAPH_DATA_SUCCESS,
    payload,
  });
  export const fetchOPGraphDataError = (payload: any) => ({
    type: OVERPAYMENT_GRAPH_DATA_FAILURE,
    payload,
  });
  
  export const fetchOverPaymentData = (payload: any) => ({
    type: OVERPAYMENT_DATA_REQUEST,
    payload,
  });
  
  export const fetchOverPaymentDataSuccess = (payload: any) => ({
    type: OVERPAYMENT_DATA_SUCCESS,
    payload,
  });
  
  export const fetchOverPaymentDataError = (payload: any) => ({
    type: OVERPAYMENT_DATA_ERROR,
    payload,
  });
  
  export const overpaymentDataLoading = (payload: any) => ({
    type: OVERPAYMENT_DATA_LOADING,
    payload,
  });
  
  export const graphDataLoading = (payload: any) => ({
    type: OVERPAYMENT_GRAPH_DATA_LOADING,
    payload,
  });
  
  // Overpayment Financial Performance Trend Graph Action Types
  
  export const fetchOverPaymentFinancialPerformanceGraphRequest = (payload: any) => ({
      type: OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_REQUEST,
      payload,
    });
  
    export const fetchOverPaymentFinancialPerformanceGraphLoading = (payload: any) => ({
      type: OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_LOADING,
      payload,
    });  
   
    export const fetchOverPaymentFinancialPerformanceGraphSuccess = (payload: any) => ({
      type: OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_SUCCESS,
      payload,
    });  
  
    export const fetchOverPaymentFinancialPerformanceGraphError = (payload: any) => ({
      type: OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_FAILURE,
      payload,
    });

  // Cancel actions
  export const cancelOverPaymentData = () => ({
    type: OVERPAYMENT_DATA_CANCEL,
  });

  export const cancelOPGraphData = () => ({
    type: OVERPAYMENT_GRAPH_DATA_CANCEL,
  });

  export const cancelOverPaymentFinancialPerformanceGraph = () => ({
    type: OVERPAYMENT_FINANCIAL_PERFORMANCE_GRAPH_DATA_CANCEL,
  });

  // Polling actions
  export const overPaymentPollingStarted = () => ({
    type: OVERPAYMENT_POLLING_STARTED,
  });

  export const overPaymentPollingCompleted = () => ({
    type: OVERPAYMENT_POLLING_COMPLETED,
  });

  export const overPaymentPollingFailed = (error?: any) => ({
    type: OVERPAYMENT_POLLING_FAILED,
    payload: error,
  });

  // On-demand subcategory fetch actions
  export const fetchOverPaymentSubCategoryRequest = (payload: { reasonName: string; apiPayload: any }) => ({
    type: OVERPAYMENT_SUBCATEGORY_REQUEST,
    payload,
  });

  export const fetchOverPaymentSubCategorySuccess = (payload: { reasonName: string; data: any }) => ({
    type: OVERPAYMENT_SUBCATEGORY_SUCCESS,
    payload,
  });

  export const fetchOverPaymentSubCategoryFailure = (payload: { reasonName: string; error: any }) => ({
    type: OVERPAYMENT_SUBCATEGORY_FAILURE,
    payload,
  });

  export const fetchOverPaymentSubCategoryLoading = (payload: { reasonName: string; loading: boolean }) => ({
    type: OVERPAYMENT_SUBCATEGORY_LOADING,
    payload,
  });
